import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
class ContactAdminPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    const user = app.session.user;
    this.loggedIn = !!user;
    this.name = user ? user.displayName() || user.username() : '';
    this.email = user && user.email ? user.email() || '' : '';
    this.subject = '';
    this.message = '';
    this.website = '';
    this.loading = false;
    this.sent = false;
    this.error = '';
    app.setTitle('Contacter l’administration');
  }
  submit(e) {
    e.preventDefault();
    if (this.loading) return;
    this.loading = true;
    this.error = '';
    this.sent = false;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/val/ui/contactadmin',
      body: {
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message,
        website: this.website
      }
    }).then(() => {
      this.sent = true;
      this.message = '';
    }).catch(error => {
      const payload = error && error.response && error.response.errors ? error.response.errors : null;
      if (payload) {
        this.error = Object.values(payload).join(' ');
      } else {
        this.error = 'Le message n’a pas pu être envoyé. Réessayez dans quelques instants.';
      }
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "ValContactAdminPage"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "ValContactAdminCard"
    }, m("h1", null, "Contacter l\u2019administration"), m("p", {
      className: "ValContactAdminIntro"
    }, "Ce formulaire permet de contacter directement l\u2019administration de Vintage Audio Laser."), this.sent && m("div", {
      className: "Alert Alert--success ValContactAdminAlert"
    }, "Votre message a bien \xE9t\xE9 envoy\xE9."), this.error && m("div", {
      className: "Alert Alert--error ValContactAdminAlert"
    }, this.error), m("form", {
      onsubmit: this.submit.bind(this)
    }, m("div", {
      className: "Form-group"
    }, m("label", null, "Nom ou pseudo"), m("input", {
      className: "FormControl",
      type: "text",
      maxlength: "120",
      value: this.name,
      readonly: this.loggedIn,
      required: true,
      oninput: e => this.name = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", null, "Adresse mail"), m("input", {
      className: "FormControl",
      type: "email",
      maxlength: "254",
      value: this.email,
      readonly: this.loggedIn,
      required: true,
      oninput: e => this.email = e.target.value
    }), m("div", {
      className: "helpText"
    }, "La r\xE9ponse sera envoy\xE9e \xE0 cette adresse.")), m("div", {
      className: "Form-group"
    }, m("label", null, "Sujet"), m("input", {
      className: "FormControl",
      type: "text",
      maxlength: "180",
      value: this.subject,
      required: true,
      oninput: e => this.subject = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", null, "Message"), m("textarea", {
      className: "FormControl ValContactAdminMessage",
      maxlength: "20000",
      value: this.message,
      required: true,
      oninput: e => this.message = e.target.value
    })), m("div", {
      className: "ValContactAdminHoneypot",
      "aria-hidden": "true"
    }, m("label", null, "Site internet", m("input", {
      type: "text",
      tabindex: "-1",
      autocomplete: "off",
      value: this.website,
      oninput: e => this.website = e.target.value
    }))), m("div", {
      className: "Form-group ValContactAdminSubmit"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading,
      disabled: this.loading
    }, "Envoyer le message"))))));
  }
}
app.initializers.add('val-ui-contact-admin', () => {
  app.routes.contactadmin = {
    path: '/contactadmin',
    component: ContactAdminPage
  };
});